import template from './sw-entity-purchase-button.html.twig';

const {
    Component
} = Shopware;

export default Component.wrapComponentConfig({
    template: template,
    computed: {
        inAppPurchaseCheckout() {
            return Shopware.Store.get('inAppPurchaseCheckout');
        },

        hideButton() {
            return Shopware.InAppPurchase.isActive('VerignDvAccessibilitySw6', 'verign-premium-accessibility-premium-sub');
        }
    },
    methods: {
        openPurchaseModal() {
            this.inAppPurchaseCheckout.request({ identifier: 'verign-premium-accessibility-premium-sub'}, 'VerignDvAccessibilitySw6');
        }
    }
});